<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <arksnackbar v-model="durumDegeri"></arksnackbar>
    <loader v-model="durumDegeri.loading"></loader>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12 v-if="baslik">
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{ baslik }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- Baslik cubugunun sagina buton/menu koymak icin. -->
              <slot name="baslikSag"></slot>
            </v-toolbar>
          </v-flex>

          <!-- pa-0: varsayilan 24px dolgu istenmiyor; sayfalar kendi
               kart/layout bosluklarini zaten veriyor. -->
          <v-container fluid pa-0>
            <!--
              Sayfanin kendi icerigi. Yetki bilgisi slot uzerinden verilir ki
              sayfa "kaydedebilir mi" gibi kararlari kendi verebilsin:

                <sayfataban v-slot="{ kaydedebilir }"> ... </sayfataban>
            -->
            <slot
              :yetki="sayfayetki"
              :sayfayiGorebilir="sayfayiGorebilir"
              :kaydedebilir="kaydedebilir"
              :guncelleyebilir="guncelleyebilir"
              :silebilir="silebilir"
            ></slot>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
/**
 * Yetkilendirmesi olan sayfalar icin TABAN SAYFA.
 *
 * Kullanimi - sayfa bu bileseni SARMALAYICI olarak kullanir:
 *
 *   <template>
 *     <sayfataban baslik="Ekran Adi">
 *       ... sayfanin kendi icerigi ...
 *     </sayfataban>
 *   </template>
 *
 *   import sayfataban from "@/components/app/customcomp/sayfataban.vue";
 *   export default { components: { sayfataban }, ... };
 *
 * Yetkiye gore bir sey gizlenecekse slot uzerinden okunur:
 *
 *   <sayfataban baslik="..." v-slot="{ kaydedebilir }">
 *     <kaydetbutonu v-if="kaydedebilir" ... />
 *   </sayfataban>
 *
 * Taban sunlari ustlenir:
 *   - sayfa acilisinda yetkinin cozulmesi (rota adina gore),
 *   - yetki yoksa uyari dialogu ve dogru yere yonlendirme,
 *   - v-app / v-card / baslik cubugu gibi her sayfada tekrarlanan cerceve.
 *
 * NEDEN BOYLE: bu blok her sayfada elle tekrarlaniyordu ve tekrarin bedeli
 * satir sayisi degil, hatalarin her kopyada ayri ayri olusmasiydi (orn.
 * prevRoute'un data()'da tanimsiz kalmasi). Ayni kalibi projede
 * carihareketbaseaktarim.vue da kullaniyor.
 *
 * KAPSAM: yeni sayfalar bunu kullanir. Mevcut sayfalar bilerek
 * dokunulmadan birakildi; toplu gecis ayri bir karar.
 */
import helpers from "@/components/app/customcomp/helpers.js";
import tool from "@/components/app/coper/tools.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
import loader from "@/components/app/coper/comp/loader.vue";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";

export default {
  name: "sayfataban",

  components: { yetkidialog, arksnackbar, hatadialog, loader },

  props: {
    /** Baslik cubugunda gosterilecek metin. Bos birakilirsa cubuk cizilmez. */
    baslik: { type: String, default: null },

    /**
     * Yetki yoksa geri donulecek adres. Verilmezse ana sayfaya donulur.
     *
     * Taban ic ice bir bilesen oldugu icin bunu KENDISI ogrenemez:
     * beforeRouteEnter yalnizca ROTA bileseninde calisir. Geldigi sayfaya
     * donmek isteyen sayfa bunu kendi beforeRouteEnter'inda doldurup
     * prop olarak verir:
     *
     *   beforeRouteEnter(to, from, next) {
     *     next((vm) => { vm.oncekiRota = from.path; });
     *   }
     *
     * (Projedeki carihareketbaseaktarim.vue'da beforeRouteEnter tabanin
     * KENDI icinde tanimli; orada ic ice bilesen oldugu icin hic calismiyor
     * ve prevRoute her zaman null kaliyor. Ayni tuzaga dusmemek icin burada
     * prop tercih edildi.)
     */
    oncekiRota: { type: String, default: null },

    /**
     * Kullaniciya kisa bilgi/uyari gostermek icin durum nesnesi.
     * <c>tool.NewSatatus()</c> bicimindedir: { show, text, loading }.
     *
     * Sayfa nesneyi kendi data'sinda tutar ve alanlarini doldurur:
     *
     *   this.durum.text = "Kayit alindi";
     *   this.durum.show = true;
     *
     * `loading` alani da isleniyor: true iken yukleniyor gostergesi cikar
     * (carihareketbaseaktarim.vue ile ayni bilesen).
     *
     * Verilmezse snackbar yine cizilir ama hicbir sey gostermez; boylece
     * kullanmayan sayfalar bir sey tanimlamak zorunda kalmaz.
     */
    durum: { type: Object, default: null },
  },

  data() {
    return {
      /**
       * Sayfa durum vermediginde kullanilan nesne. data'da TUTULUYOR:
       * computed icinde her cagride yenisi uretilseydi, tabanin kendi
       * gosterdigi mesajlar (bkz. Hata) ekrana hic gelmezdi.
       */
      varsayilanDurum: tool.NewSatatus(),

      /** helpers.pageScreenAuth sonucu. Sayfa acilisinda doldurulur. */
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        // 0 onceki sayfaya don, 1 ana sirket sec, 2 cikis yap.
        islem: 0,
      },
    };
  },

  computed: {
    /**
     * Snackbar'a verilecek nesne. Sayfa durum vermediyse bos bir tane
     * uretilir; arksnackbar her zaman gecerli bir nesne bekliyor.
     */
    durumDegeri() {
      return this.durum == null ? this.varsayilanDurum : this.durum;
    },

    sayfayiGorebilir() {
      return this.sayfayetki.Status === true;
    },

    kaydedebilir() {
      return this.sayfayetki.Status === true && this.sayfayetki.Save === true;
    },

    guncelleyebilir() {
      return this.sayfayetki.Status === true && this.sayfayetki.Update === true;
    },

    silebilir() {
      return this.sayfayetki.Status === true && this.sayfayetki.Delete === true;
    },
  },

  mounted() {
    this.SayfaYetkisiUygula();
  },

  methods: {
    /**
     * Sayfa yetkisini cozer; yetki yoksa kullaniciyi bilgilendirip gonderir.
     *
     * Yetki ROTA ADINA gore cozuluyor (sunucudaki WebPages kaydi). Yeni bir
     * sayfa acarken o kayit yoksa Status false doner ve sayfa acilmaz.
     *
     * Rota adi TABANIN degil, SAYFANIN adidir: taban ic ice bir bilesen olsa
     * da $route her ikisinde de aynidir.
     */
    SayfaYetkisiUygula() {
      var rotaAdi = this.$route ? this.$route.name : null;
      this.sayfayetki = helpers.pageScreenAuth(rotaAdi);

      if (this.sayfayetki.Status === true) return Promise.resolve(true);

      var dialog = this.$refs ? this.$refs.yetkidialog : null;
      if (!dialog) {
        this.YetkisizCik();
        return Promise.resolve(false);
      }

      // islem 0 -> dialog "Onceki Sayfa" gosterir ve true ile cozulur,
      // yonlendirmeyi BIZ yapariz. islem 1 (ana sirket secimi) ve 2 (cikis)
      // dialogun kendi isidir ve false ile cozulur; orada yonlendirirsek
      // dialogun gonderdigi adresi ezeriz.
      return dialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc === true) this.YetkisizCik();
          return false;
        });
    },

    /**
     * Basarisiz bir istegi kullaniciya bildirir.
     *
     * 500'de ayrintili dialog acilir: govdede sunucunun tam yaniti ve
     * gonderilen istek durur, ayrica "Arkman'a e-posta gonder" dugmesi
     * vardir. Sunucu hatalarinin tesphisi genellikle o govdededir
     * (orn. "Invalid object name 'X'"); snackbar'da kirpilip kaybolur.
     *
     * Diger durumlarda kisa mesaj snackbar'da gosterilir.
     */
    Hata(cevap, istek, baslik) {
      var durumKodu = cevap ? cevap.status : null;

      if (durumKodu === 500 && this.$refs && this.$refs.hatadialog) {
        this.$refs.hatadialog.open(cevap, istek, baslik);
        return;
      }

      // $t BAGLANMALI: HataMesajiCoz ceviri fonksiyonunu bagsiz cagiriyor
      // ve vue-i18n'in $t'si this.$i18n'e bakiyor. Bagsiz gecilirse baglanti
      // koptugunda (status 0, "Service-Unavailable" dali) hata dalinin
      // KENDISI TypeError firlatiyor ve kullanici hicbir mesaj gormuyor.
      var d = this.durumDegeri;
      d.text = baslik + ": " + tool.HataMesajiCoz(cevap, this.$t.bind(this));
      d.show = true;
    },

    /** Geldigi sayfaya, bilinmiyorsa ana sayfaya dondurur. */
    YetkisizCik() {
      window.open("#" + (this.oncekiRota || "/"), "_self");
    },
  },
};
</script>
